module.exports = __webpack_public_path__ + "static/img/homeDiarioBusca.9b734f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/homeDiarioBusca.png
// module id = Co5Y
// module chunks = 1